import { createReducer } from 'typesafe-actions';
import { UserActions } from '../actions/user';

interface UserState {
    isLoggedOn?: boolean;
    fullName?: string;
    email?: string;
}
const defaultUserState: UserState = {};
export const userReducer = createReducer<UserState, UserActions>(defaultUserState)
    .handleAction(UserActions.userInfoReceived, (state, { payload }) => ({
        ...state,
        email: payload.emailAddress,
        fullName: payload.fullName,
    }))
    .handleAction(UserActions.isLoggedOn, (state, { payload }) => ({ ...state, isLoggedOn: payload }));
